import React from 'react';

import { Badge, Button, Icon, Typography } from '@sravni/react-design-system';
import { Wallet } from '@sravni/react-icons';

import {
    FULL_DEAL_ENTRY_POINT_TEXTS,
    ONE_LINK,
    WEB_FULL_DEAL_LINK,
} from '@src/containers/list/ProductList/FullDealEntryPoint/сonsts';
import { sendOpenAppFullDealEvent, sendOpenWebFullDealEvent } from '@src/helpers/analyticsEvents';
import { useMicrocreditUserDealsState } from '@src/reducers/microcreditUserDeals';

import styles from './styles.module.scss';

const { Heading } = Typography;

export const FullDealEntryPoint = () => {
    const microcreditDeals = useMicrocreditUserDealsState();
    const hasIssuedMicrocreditDeals = microcreditDeals.some((deal) => deal.status === 'issued');

    const handleOpenWebFullDeal = (event: React.SyntheticEvent) => {
        event.stopPropagation();

        window.location.href = WEB_FULL_DEAL_LINK;
        sendOpenWebFullDealEvent();
    };

    const handleOpenMobileApp = (event: React.SyntheticEvent) => {
        event.stopPropagation();
        window.open(ONE_LINK, '_blank');

        sendOpenAppFullDealEvent();
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.heading}>
                <div className={styles.iconBlock}>
                    <div className={styles.iconWrapper}>
                        <Icon icon={<Wallet />} size={20} />
                    </div>
                    <Heading level={5}>{FULL_DEAL_ENTRY_POINT_TEXTS.heading}</Heading>
                </div>
                <Badge variant="primary" color="green" text="Высокое одобрение" />
            </div>
            <div className={styles.text}>{FULL_DEAL_ENTRY_POINT_TEXTS.description}</div>
            <div className={styles.buttonsBlock}>
                <Button block variant="primary" color="blue" onClick={handleOpenWebFullDeal}>
                    {FULL_DEAL_ENTRY_POINT_TEXTS.redirectButtonText}
                </Button>
                {hasIssuedMicrocreditDeals && (
                    <Button block color="gray" onClick={handleOpenMobileApp}>
                        {FULL_DEAL_ENTRY_POINT_TEXTS.mobileAppButtonText}
                    </Button>
                )}
            </div>
        </div>
    );
};
